import { useState } from "react";
import MainLayout from "@/components/feature/MainLayout";
import ReportBuilder from "../components/ReportBuilder";

export default function CustomReportPage() {
  return (
    <MainLayout>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold text-gray-900">自定义报表</h2>
            <p className="text-xs text-gray-400 mt-0.5">自由选择数据字段，生成个性化报表</p>
          </div>
        </div>
        <ReportBuilder />
      </div>
    </MainLayout>
  );
}
